<template>
  <div class="hall-detail">
    <div class="hall-head">
      <el-button class="hall-report" type="primary">
        <img src="@/assets/images/a-jiluwendang 2@2x.png" class="hall-report-icon" alt="">
        生成数据报告
      </el-button>
      <div class="hall-head-main">
        <img v-if="coverSrc" :src="coverSrc" class="hall-cover" alt="">
        <GsMediaPh v-else class="hall-cover" label="暂无图片" />
        <div class="hall-head-copy">
          <h1 class="hall-title">{{ pageTitle }}</h1>
          <div class="hall-sub">
            <span>挂牌企业：</span>
            <EnterpriseLink :id="enterpriseId" :name="enterpriseName" />
          </div>
          <div v-if="tagList.length" class="hall-tags">
            <span
              v-for="(tag, index) in tagList"
              :key="index"
              class="hall-tag"
              :class="{ 'is-mute': index > 2 }"
            >{{ tag }}</span>
          </div>
        </div>
      </div>
      <div class="hall-intro">
        <span class="hall-intro-label">产品简介：</span>
        <div v-if="introText" class="hall-intro-text">{{ introText }}</div>
        <div v-else class="gs-text-ph">产品简介暂未公开，后续将补充应用场景、数据内容与规格说明。</div>
      </div>
    </div>

    <div class="hall-block">
      <TitleTool title="交易单信息" />
      <div class="hall-panel">
        <div class="hall-grid is-3">
          <div
            class="hall-field"
            v-for="(item, index) in tradeFields"
            :key="item.label"
            :class="{
              'is-row-end': (index + 1) % 3 === 0 || index === tradeFields.length - 1,
              'is-last-row': tradeFields.length % 3 !== 0 && index >= tradeFields.length - (tradeFields.length % 3),
            }"
          >
            <span class="hall-label">{{ item.label }}：</span>
            <div class="hall-value">
              <EnterpriseLink v-if="item.enterpriseId" :id="item.enterpriseId" :name="item.value" />
              <GsVal v-else :value="item.value" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="hall-block">
      <TitleTool title="产品参数" />
      <div class="hall-panel">
        <div class="hall-grid is-2">
          <div class="hall-field">
            <span class="hall-label">数据产品规格说明：</span>
            <div class="hall-value"><GsVal :value="ruleForm.productSpecification" /></div>
          </div>
          <div class="hall-field">
            <span class="hall-label">产品评价：</span>
            <div class="hall-value"><GsVal :value="ruleForm.productEvaluation" /></div>
          </div>
        </div>
        <div class="hall-field is-wide">
          <span class="hall-label">数据内容详情：</span>
          <div class="hall-value is-long"><GsVal :value="ruleForm.dataContentIntroduction" /></div>
        </div>
      </div>
    </div>

    <div class="hall-block">
      <TitleTool title="交易进度" />
      <div class="hall-panel">
        <div class="hall-steps" role="list" aria-label="交易进度">
          <div
            v-for="step in progressSteps"
            :key="step.value"
            class="hall-step"
            :class="stepState(step.value)"
            role="listitem"
          >
            <span class="hall-step-no">{{ step.id }}</span>
            <span class="hall-step-name">{{ step.title }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="hall-actions">
      <button v-if="ruleForm.datasetId" type="button" class="hall-btn" @click="goDataset">查看数据集档案</button>
    </div>
  </div>
</template>

<script>
import { getTradeDetail } from "@/api/api";
import { P, routeId } from '@/router/paths'
import GsVal from '@/components/GsVal/index.vue'
import GsMediaPh from '@/components/GsMediaPh/index.vue'
import EnterpriseLink from '@/components/EnterpriseLink/index.vue'
import { TRADE_PROGRESS_STEPS, tradeProgressState } from '@/utils/tradeProgress'

export default {
  name: 'DataChangedetail',
  components: { GsVal, GsMediaPh, EnterpriseLink },
  data() {
    return {
      progressSteps: TRADE_PROGRESS_STEPS,
      ruleForm: {},
      prodUrl: 'https://shujuzichan.com/xwzx'
    };
  },
  computed: {
    pageTitle() {
      return this.ruleForm.tradeName || this.ruleForm.datasetName || this.ruleForm.sellListingName || '数据交易详情'
    },
    enterpriseId() {
      return this.ruleForm.sellEnterpriseId || ''
    },
    enterpriseName() {
      return this.ruleForm.sellEnterpriseName || this.ruleForm.sellListingName || ''
    },
    findSellLabel() {
      return this.ruleForm.buyListingId ? '已撮合' : '待撮合'
    },
    coverSrc() {
      const src = this.ruleForm.coverPicture || this.ruleForm.logoPicture || this.ruleForm.homePicture || this.ruleForm.productPicture || ''
      if (!src) return ''
      if (/^https?:\/\//i.test(src)) return src
      return this.prodUrl + src
    },
    introText() {
      return (
        this.ruleForm.dataContentIntroduction ||
        this.ruleForm.sellRequirement ||
        this.ruleForm.productSpecification ||
        this.ruleForm.dataApplicationScenarios ||
        ''
      ).toString().trim()
    },
    tagList() {
      return [
        this.findSellLabel,
        this.ruleForm.industryName || this.ruleForm.industryClassification,
        '数据交易'
      ].filter((item) => item && String(item).trim())
    },
    tradeFields() {
      return [
        { label: '数据交易所', value: this.ruleForm.exchangeName },
        { label: '撮合状态', value: this.findSellLabel },
        { label: '关联数据集', value: this.ruleForm.datasetName },
        { label: '价格说明', value: this.ruleForm.priceDescription },
        { label: '交易金额', value: this.ruleForm.transactionAmount },
        { label: '交易数量', value: this.ruleForm.transactionNumber },
        { label: '适用场景', value: this.ruleForm.dataApplicationScenarios },
        { label: '接口信息', value: this.ruleForm.interfaceInformation },
        { label: '发布时间', value: this.ruleForm.createTime },
        // 买方 / 卖方企业放到最下面
        { label: '卖方企业', value: this.ruleForm.sellListingName || this.ruleForm.sellEnterpriseName, enterpriseId: this.enterpriseId },
        { label: '买方企业', value: this.ruleForm.buyListingName || this.ruleForm.buyEnterpriseName || '待撮合', enterpriseId: this.ruleForm.buyEnterpriseId }
      ]
    }
  },
  created() {
    this.loadEnterpriseDetail();
  },
  watch: {
    '$route.params.id'() {
      this.loadEnterpriseDetail()
    }
  },
  methods: {
    loadEnterpriseDetail () {
      const id = routeId(this.$route)
      if (!id) return
      getTradeDetail(id).then((response) => {
        this.ruleForm = response.data || {};
      });
    },
    stepState(stepValue) {
      return tradeProgressState(stepValue, this.ruleForm.transactionProgress)
    },
    goDataset() {
      const id = this.ruleForm.datasetId
      if (!id) return
      this.$router.push(P.datasetDetail(id))
    }
  },
};
</script>

<style scoped lang="css">
.hall-detail {
  width: 100%;
  max-width: none;
  margin: 0 auto;
  padding: 8px 0 48px;
}
.hall-head {
  position: relative;
  background: #fff;
  border-radius: 12px;
  padding: 22px 22px 16px;
  margin-bottom: 16px;
  box-shadow: 0 8px 20px rgba(1, 101, 255, 0.04);
}
.hall-report {
  position: absolute;
  right: 18px;
  top: 16px;
  z-index: 1;
}
.hall-report.el-button--primary {
  background: #E8F2FF;
  border-color: #E8F2FF;
  color: #0165FF;
  border-radius: 8px;
  font-size: 16px;
  height: 42px;
  padding: 0 12px;
}
.hall-report-icon {
  width: 22px;
  height: 24px;
  margin-right: 4px;
}
.hall-head-main {
  display: flex;
  align-items: center;
  gap: 20px;
  padding-right: 180px;
  min-height: 106px;
}
.hall-cover {
  width: 106px;
  height: 106px;
  border-radius: 10px;
  object-fit: cover;
  flex-shrink: 0;
}
.hall-title {
  margin: 0 0 10px;
  font-size: 28px;
  line-height: 36px;
  color: #111824;
  font-weight: 700;
}
.hall-sub {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 10px;
  font-size: 15px;
  color: #333;
}
.hall-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.hall-tag {
  background: #D6E5FE;
  color: #0165FF;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 12px;
  line-height: 16px;
}
.hall-tag.is-mute {
  background: #E2E2E2;
  color: #333;
}
.hall-intro {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid #F0F4FA;
}
.hall-intro-label {
  flex-shrink: 0;
  width: 84px;
  font-size: 15px;
  color: #333;
  line-height: 22px;
}
.hall-intro-text {
  flex: 1;
  font-size: 14px;
  line-height: 22px;
  color: #4B5563;
}
.gs-text-ph {
  flex: 1;
  min-width: 0;
  padding: 10px 12px;
  border-radius: 8px;
  background: linear-gradient(90deg, #F4F8FF 0%, #FFFFFF 100%);
  border: 1px dashed #C5D8F7;
  color: #7B8BA3;
  font-size: 13px;
  line-height: 22px;
}
.hall-block {
  background: rgba(75, 145, 255, 0.07);
  border-radius: 8px;
  padding: 18px 16px 12px;
  margin-bottom: 16px;
}
.hall-sec-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  font-size: 20px;
  font-weight: 700;
  color: #111824;
  line-height: 24px;
}
.hall-sec-icon {
  width: 28px;
  height: 18px;
}
.hall-panel {
  background: #fff;
  border-radius: 8px;
  padding: 8px 8px 4px;
}
.hall-steps {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 8px 4px 12px;
}
.hall-step {
  flex: 1 1 140px;
  min-width: 120px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: transparent;
  text-align: left;
  font-family: inherit;
  pointer-events: none;
}
.hall-step.is-done {
  opacity: 0.92;
}
.hall-step.is-current {
  background: #F4F8FF;
  border-color: #0165FF;
}
.hall-step.is-todo {
  opacity: 0.55;
}
.hall-step-no {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #D0D7E2;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
}
.hall-step.is-done .hall-step-no,
.hall-step.is-current .hall-step-no {
  background: #0165FF;
}
.hall-step-name {
  font-size: 13px;
  color: #1D2B44;
}
.hall-grid {
  display: grid;
}
.hall-grid.is-3 {
  grid-template-columns: 1fr 1fr 1fr;
}
.hall-grid.is-2 {
  grid-template-columns: 1fr 1fr;
}
.hall-field {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 48px;
  padding: 8px 10px;
  border-right: 1px solid rgba(118, 118, 118, 0.13);
  border-bottom: 1px solid rgba(118, 118, 118, 0.08);
}
.hall-grid .hall-field:nth-child(3n) {
  border-right: none;
}
/* 末行（不足 3 个）不要残留分割线 */
.hall-grid .hall-field.is-last-row {
  border-bottom: none;
}
.hall-grid .hall-field.is-row-end {
  border-right: none;
}
.hall-grid .hall-field.is-last-row.is-row-end {
  border-right: none;
}
.hall-grid.is-2 .hall-field {
  border-right: 1px solid rgba(118, 118, 118, 0.13);
}
.hall-grid.is-2 .hall-field:nth-child(2n) {
  border-right: none;
}
.hall-field.is-wide {
  border-right: none;
  align-items: flex-start;
  padding: 12px 10px 16px;
}
.hall-label {
  flex-shrink: 0;
  width: 118px;
  font-size: 14px;
  color: #333;
  line-height: 22px;
}
.hall-value {
  flex: 1;
  min-width: 0;
  min-height: 32px;
  display: flex;
  align-items: center;
  padding: 4px 10px;
  background: #F4F6F8;
  border-radius: 6px;
}
.hall-value.is-long {
  align-items: flex-start;
  min-height: 64px;
  padding: 10px;
}
@media (max-width: 960px) {
  .hall-head-main {
    padding-right: 0;
    padding-top: 48px;
    align-items: flex-start;
  }
  .hall-title {
    font-size: 22px;
    line-height: 30px;
  }
  .hall-grid.is-3,
  .hall-grid.is-2 {
    grid-template-columns: 1fr;
  }
  .hall-field,
  .hall-grid .hall-field:nth-child(3n),
  .hall-grid.is-2 .hall-field,
  .hall-grid.is-2 .hall-field:nth-child(2n) {
    border-right: none;
  }
  .hall-label {
    width: 96px;
    font-size: 13px;
  }
}
.hall-actions {
  display: flex;
  gap: 12px;
}
.hall-btn {
  height: 40px;
  padding: 0 16px;
  border: 1px solid #0165FF;
  border-radius: 8px;
  background: #fff;
  color: #0165FF;
  cursor: pointer;
  font-family: inherit;
  font-size: 14px;
}
</style>
